var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeamerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4803_135823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.02762 12.2749C2.10931 11.7691 2.63899 11.4759 3.03175 11.3234C8.60245 9.16039 14.1882 7.03104 19.7754 4.90526C20.6951 4.55532 21.5401 4.85677 21.8678 5.59342C22.1948 6.32867 21.806 7.07054 20.8637 7.43306C15.3405 9.55795 9.81665 11.6815 4.28635 13.7903C2.91485 14.3133 2.00906 13.716 2.02762 12.2749Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02762 17.5347C2.10931 17.0288 2.63899 16.7356 3.03175 16.5831C8.60245 14.4202 14.1882 12.2908 19.7754 10.165C20.6951 9.81509 21.5401 10.1165 21.8678 10.8532C22.1948 11.5884 21.806 12.3303 20.8637 12.6928C15.3405 14.8177 9.81665 16.9413 4.28635 19.0501C2.91485 19.573 2.00906 18.9758 2.02762 17.5347Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3634 18.532C16.4466 19.6239 13.6036 20.7172 10.7452 21.7742C9.74635 22.1435 8.97201 21.8613 8.64766 21.1119C8.33032 20.3787 8.65953 19.6834 9.66308 19.2959C13.049 17.9884 16.4484 16.7105 19.8559 15.4527C20.7596 15.1191 21.5494 15.4496 21.851 16.1694C22.1492 16.8813 21.8035 17.5582 20.9057 17.954C20.4259 18.1655 19.9234 18.3322 19.3634 18.532Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.05258 7.73386C1.84226 6.78464 2.27564 6.23537 3.12404 5.91651C6.49168 4.65083 9.85669 3.37892 13.2309 2.12869C14.1093 1.80321 14.9362 2.11734 15.2404 2.82047C15.5591 3.55735 15.2581 4.24149 14.3203 4.60516C11.3241 5.76689 8.30993 6.88808 5.30218 8.0237C4.91989 8.16804 4.53765 8.31336 4.1499 8.44405C3.09906 8.79823 2.37737 8.68534 2.05258 7.73386Z",
    fill: "#858585"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4803_135823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeamerIcon);
export default __webpack_public_path__ + "static/media/beamer-icon.7cf0d48a.svg";
export { ForwardRef as ReactComponent };